var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{ [`button_${_vm.type}`]: true, button_loading: _vm.loading, button_disabled: _vm.disabled }},[(_vm.loading)?_c('loader',{attrs:{"size":"15px","border":"3px","absolute":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }